module.exports = __webpack_public_path__ + "static/media/mobile-payment-gray.1f8f89c7.svg";